export default function (customers, workList) {
  const values = []

  customers.forEach(customer => {
    let hours = 0

    for (const work of workList) {
      if (work.responsible === customer) {
        hours = work.amount_of_time
        break
      }
    }

    values.push({ data: hours, mod: '' })
  })

  return values
}
